import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
const CRadiobutton = (props) => {
  let choices = [];
  choices = props.choiceListArray;
  const labelName = props.labelName;
  const name = props.name;
  const isInline = props.isInline === true ? true : false;
  const required = props.required === true ? true : false;
  const hidden = props.hidden === true ? true : false;
  const disabled = props.disabled === true ? true : false;
  const defaultChecked =
    props.defaultChecked === undefined ? "" : props.defaultChecked;
  const labelCustomStyle =
    props.labelCustomStyle === undefined ? {} : props.labelCustomStyle;
  const inputCustomStyle =
    props.inputCustomStyle === undefined ? {} : props.inputCustomStyle;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassInput =
    props.customClassInput === undefined ? "" : props.customClassInput;
  const customClassDiv =
    props.customClassDiv === undefined ? "" : props.customClassDiv;
  const faIcon = props.faIcon === undefined ? "" : props.faIcon;
  const faTitle = props.faTitle === undefined ? "" : props.faTitle;
  const faClass = props.faClass === undefined ? "" : props.faClass;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");

  const checkRequired = (choice) => {
    if (choice.length > 0) {
      setErrorMsg("");
      setIsValid("");
      props.functionName(name, choice);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please choose one");
    }
  };

  return (
    <>
      <div className={`${isValid}  ${customClassDiv}`}>
        <div>
          <label
            className={`form-label ${customClassLabel}`}
            style={labelCustomStyle}
          >
            {labelName}
            <FontAwesomeIcon icon={faIcon} title={faTitle} className={faClass}/>
          </label>
        </div>
        {choices.map((item, index) => (
          <div
            className={
              isInline === true ? "form-check form-check-inline" : "form-check"
            }
            style={inputCustomStyle}
          >
            <input
              type="radio"
              className={`form-check-input ${customClassInput}`}
              value={item.value}
              defaultChecked={item.value === defaultChecked ? true : false}
              id={item.id === undefined ? "" : item.id}
              name={name}
              required={required}
              hidden={hidden}
              disabled={disabled}
              onClick={(event) => {
                required === true
                  ? checkRequired(event.target.value)
                  : props.functionName(name, event.target.value);
              }}
            />
            <label className="form-check-label">{item.label}</label>
            {index === choices.length - 1 ? (
              <div className="invalid-feedback">{errorMsg}</div>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CRadiobutton;
